import React from "react";
import styled from "styled-components";
import Skeleton from "common/NewLook/Skeleton.tsx";

/**
 * New look: the copy form's placeholder while the public bot loads — its
 * labels and fields where the real ones will be, and its two actions.
 */
const PublicBotSummarySkeleton = () => (
  <Wrapper aria-busy="true">
    {[0, 1, 2].map((index) => (
      <Field key={index}>
        <Skeleton width={index ? "28%" : "22%"} height={12} />
        <Skeleton width="100%" height={36} radius={8} />
      </Field>
    ))}
    <Columns>
      {[0, 1].map((index) => (
        <Field key={index}>
          <Skeleton width="40%" height={12} />
          <Skeleton width="100%" height={36} radius={8} />
        </Field>
      ))}
    </Columns>
    <Skeleton width="100%" height={72} radius={8} />
    <Columns>
      <Skeleton width="100%" height={36} radius={999} />
      <Skeleton width="100%" height={36} radius={999} />
    </Columns>
  </Wrapper>
);

export default React.memo(PublicBotSummarySkeleton);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;
const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`;
